module.exports = __webpack_public_path__ + "static/media/border.4e4c34b3.png";